"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _semanticUiReact = require("semantic-ui-react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactScroll = require("react-scroll");
var _v = _interopRequireDefault(require("uuid/v4"));
var _Button = _interopRequireWildcard(require("../../ui/Button"));
var _constants = require("../constants");
var _hooks = require("./hooks");
var _styles = _interopRequireDefault(require("./styles"));
var _close = _interopRequireDefault(require("./img/close.svg"));
var _arrow_upward = _interopRequireDefault(require("./img/arrow_upward.svg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var Modal = function Modal(_ref) {
  var initialID = _ref.id,
    initialRootID = _ref.rootID,
    className = _ref.className,
    children = _ref.children,
    closeIcon = _ref.closeIcon,
    rootClassName = _ref.rootClassName,
    size = _ref.size,
    _onClose = _ref.onClose,
    centered = _ref.centered;
  var id = (0, _react.useMemo)(function () {
    return initialID || (0, _v.default)();
  }, [initialID]);
  var rootID = (0, _react.useMemo)(function () {
    return initialRootID || (0, _v.default)();
  }, [initialRootID]);
  var _useScrollOffset = (0, _hooks.useScrollOffset)(),
    isOnScreenScrolled = _useScrollOffset.isOnScreenScrolled,
    setScrollAreaRef = _useScrollOffset.setScrollAreaRef;
  var combinedRef = (0, _react.useCallback)(function (ref) {
    if (!ref) return;
    if (rootClassName) ref.dimmerRef.current.classList.add(rootClassName);
    if (centered) ref.dimmerRef.current.classList.add(_styles.default.centeredModal);
    ref.dimmerRef.current.setAttribute('id', rootID);
    setScrollAreaRef(ref.dimmerRef);
  }, [centered, rootClassName, rootID, setScrollAreaRef]);
  var onScrollToUp = (0, _react.useCallback)(function () {
    _reactScroll.scroller.scrollTo(id, {
      duration: 500,
      delay: 0,
      smooth: true,
      containerId: rootID
    });
  }, [id, rootID]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Modal, {
    open: true,
    className: (0, _classnames.default)(_styles.default.modalRoot, className),
    closeIcon: closeIcon ? /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: _styles.default.closeIcon,
      activeTheme: _Button.THEMES.PURPLE,
      icon: _close.default,
      theme: _Button.THEMES.TRANSPARENT
    }) : undefined,
    id: id,
    ref: combinedRef,
    size: size,
    onClose: function onClose() {
      return _onClose();
    }
  }, children), isOnScreenScrolled && /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.toUpButtonWrapper
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: _styles.default.toUpButton,
    icon: _arrow_upward.default,
    theme: _Button.THEMES.GRAY,
    height: _Button.HEIGHTS.FLUID,
    width: _Button.WIDTHS.FLUID,
    onClick: onScrollToUp
  })));
};
Modal.propTypes = {
  children: _propTypes.default.any,
  className: _propTypes.default.string,
  closeIcon: _propTypes.default.bool,
  centered: _propTypes.default.bool,
  id: _propTypes.default.string,
  rootClassName: _propTypes.default.string,
  rootID: _propTypes.default.string,
  size: _propTypes.default.oneOf(Object.values(_constants.SIZES)),
  onClose: _propTypes.default.func
};
Modal.defaultProps = {
  rootClassName: ''
};
var _default = exports.default = (0, _react.memo)(Modal);